"use client";

import Image from "next/image";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import Balancer from "react-wrap-balancer";

import { useLang } from "@/hooks/use-lang";
import emptyImage from "@/public/global/empty.svg";

import { Skeletons } from "ui/widget/skeletons";

import { useSessionListData } from "../services/get-session-list-data";
import { QuestionItem } from "./QuestionItem";

export const QuestionItems = () => {
  const { data, isLoading, isError } = useSessionListData();
  const pathname = usePathname();
  const [activeId, setActiveId] = useState<string | null>(null);

  useEffect(() => {
    const sessionId = pathname.split("/").pop();
    if (sessionId) setActiveId(sessionId);
  }, [pathname]);

  if (isLoading || isError)
    return <Skeletons className="pt-4" rows={6} rowHeight="3rem" />;

  return (
    <div className="flex h-full flex-col divide-y overflow-y-scroll scrollbar-hide">
      {data?.length === 0 && <EmptyView />}
      {data?.map(({ sessionId: id, title, questionType, createdAt }, index) => (
        <QuestionItem
          key={id}
          id={id}
          title={title}
          questionType={questionType}
          date={createdAt}
          data-testid={`question-item-${index}`}
          onClick={() => setActiveId(id)}
          isActive={activeId === id}
        />
      ))}
    </div>
  );
};

const EmptyView = () => {
  const { t } = useLang();
  return (
    <div className="flex flex-col items-center gap-4 py-10 text-center text-sm text-neutral-500">
      <Image src={emptyImage} alt="empty" />
      <p>
        <Balancer>{t.winwingpt.noQuestion}</Balancer>
      </p>
    </div>
  );
};
